import React from "react";
import { ArrowRight, Zap } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function FinalCallToAction() {
  return <section data-section-id="231436" id="call-to-action" className="relative overflow-hidden bg-background border-b-4 border-primary py-24 md:py-32">
      {/* Background ambient light */}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,var(--color-muted)_0%,transparent_70%)] opacity-30 pointer-events-none" />

      {/* Decorative Blueprint/Hex Pattern */}
      <svg className="absolute inset-0 w-full h-full opacity-10 pointer-events-none" xmlns="http://www.w3.org/2000/svg">
        <defs>
          <pattern id="hexagons-pattern" width="24" height="41.569" patternUnits="userSpaceOnUse" patternTransform="scale(2.5)">
            <path d="M12 0l12 6.928v13.856L12 27.712 0 20.784V6.928z" fill="none" stroke="currentColor" strokeWidth="0.5" />
            <path d="M12 41.569l12-6.928V20.784L12 13.856 0 20.784v13.856z" fill="none" stroke="currentColor" strokeWidth="0.5" />
          </pattern>
        </defs>
        <rect width="100%" height="100%" fill="url(#hexagons-pattern)" className="text-primary" />
      </svg>

      <div className="container relative z-10 mx-auto px-4 md:px-6 flex flex-col items-center text-center">
        {/* Badge */}
        <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary/10 text-primary text-sm font-medium mb-8 border border-primary/20">
          <Zap className="w-4 h-4" />
          <span>Certified Florida Inspectors</span>
        </div>

        {/* Heading */}
        <h2 className="font-default text-4xl md:text-5xl lg:text-6xl font-bold text-foreground mb-6 tracking-tight max-w-4xl">
          Secure your home's future. <br className="hidden md:block" />
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-primary to-secondary">
            Book your inspection today.
          </span>
        </h2>

        {/* Subtitle */}
        <p className="text-lg md:text-xl text-muted-foreground mb-10 max-w-2xl font-default">
          South Florida homeowners and real estate professionals rely on our inspection services.
        </p>

        {/* CTAs */}
        <div className="flex flex-col sm:flex-row items-center gap-4 w-full sm:w-auto">
          <Link to="https://trusted-fl.com/#schedule-your-inspection" className="w-full sm:w-auto">
            <Button size="lg" className="w-full sm:w-auto h-14 px-8 text-lg font-semibold bg-primary text-primary-foreground hover:bg-primary/90 shadow-lg shadow-primary/20 transition-all duration-300 hover:shadow-xl hover:shadow-primary/30 hover:-translate-y-0.5">
              Schedule Inspection
              <ArrowRight className="ml-2 w-5 h-5" />
            </Button>
          </Link>
          
          <Link to="https://trusted-fl.com/#our-inspection-services" className="w-full sm:w-auto">
            <Button variant="outline" size="lg" className="w-full sm:w-auto h-14 px-8 text-lg font-semibold border-border hover:bg-accent hover:text-accent-foreground transition-colors">
              View Our Services
            </Button>
          </Link>
        </div>
        
        {/* Coverage Subtext */}
        <div className="mt-12 pt-8 border-t border-border/50 flex flex-col items-center">
          <p className="text-sm text-muted-foreground mb-4 font-default">
            Licensed and Insured Professionals serving
          </p>
          <div className="flex flex-wrap justify-center gap-8 opacity-60 grayscale">
            {/* Minimalist county/city badges */}
            <div className="text-xl font-bold font-default tracking-wider">MIAMI</div>
            <div className="text-xl font-bold font-default tracking-wider">BROWARD</div>
            <div className="text-xl font-bold font-default tracking-wider">HOMESTEAD</div>
          </div>
        </div>
      </div>
    </section>;
}